export default __webpack_public_path__ + "static/media/trustWallet.6f5dd772.png";